import { collectionEngineV1 } from '../apis.js';
const reqAPI = collectionEngineV1('/debt-register');
export const getRegistries = (caseId) => reqAPI('GET', `/registries/${caseId}`);
export const rkiReport = (id, caseId, claim, personName, files) => reqAPI('POST', `/rki/${id}`, {
    body: { caseId, claim, personName, files },
});
export const rkiDelete = (id, caseId, rkiReferenceId, reason) => reqAPI('DELETE', `/rki/${id}?caseId=${caseId}&reason=${reason}&rkiReferenceId=${rkiReferenceId}`);
export const rkiStatus = (id, caseId, rkiReferenceId) => reqAPI('GET', `/rki/${id}/${caseId}/${rkiReferenceId}`);
export const rkiMoveToOpen = (id, caseId, rkiReferenceId, claim, files) => reqAPI('POST', `/rki/move-to-open/${id}`, {
    body: { caseId, rkiReferenceId, claim, files },
});
export const rkiConclude = (id, caseId, rkiReferenceId) => reqAPI('POST', `/rki/conclude/${id}`, {
    body: { caseId, rkiReferenceId },
});
export const rkiError = (id, caseId, rkiReferenceId, error) => reqAPI('POST', `/rki/error/${id}`, {
    body: { caseId, error, rkiReferenceId },
});
export const rkiSyncAnalyze = (fileId) => reqAPI('POST', '/rki-sync/analyze', { body: { fileId } });
export const rkiSyncImport = (fileId) => reqAPI('POST', '/rki-sync/import', { body: { fileId } });
export const rkiSyncStatus = (runId) => reqAPI('GET', `/rki-sync/status/${runId}`);
export const rkiStatusSyncStart = () => reqAPI('POST', '/rki-status-sync/start', { body: {} });
export const rkiStatusSyncStatus = (runId) => reqAPI('GET', `/rki-status-sync/status/${runId}`);
export const dbrReport = (id, caseId, claim, personName) => reqAPI('POST', `/debitorregistret/${id}`, {
    body: { caseId, claim, personName },
});
export const dbrDelete = (id, caseId, dbrRegistrationId, reason) => reqAPI('DELETE', `/debitorregistret/${id}?caseId=${caseId}&reason=${reason}&dbrRegistrationId=${dbrRegistrationId}`);
export const dbrStatus = (id, caseId, dbrRegistrationId) => reqAPI('GET', `/debitorregistret/${id}/${caseId}/${dbrRegistrationId}`);
export const dbrSetupCreditors = () => reqAPI('POST', '/debitorregistret/creditors/setup');
export const dbrSetupCreditor = (creditorId) => reqAPI('POST', `/debitorregistret/creditors/${creditorId}/setup`);
//# sourceMappingURL=debt-register.js.map